module.exports = __webpack_public_path__ + "img/contrast.c16c3b5e.svg";